var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtCarouselWheelBarrow = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v60H0V0z",
    id: "ak0wj3pdba"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    xlinkHref: "#ak0wj3pdba"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v60H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    transform: "translate(4 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.744 2.124 37.116 0c.25.027.625.106.995.357.979.666 1.007 1.927 1.008 2.073l-3.526 2.522-1.85-2.828z",
    fill: "#ECB24A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F8C75F",
    fillRule: "nonzero",
    transform: "rotate(-33.38 34.67 3.54)",
    cx: 34.67,
    cy: 3.54,
    rx: 1,
    ry: 1.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.625 9.504 3.372-2.124c.25.027.626.106.995.357.98.666 1.007 1.927 1.008 2.073l-3.525 2.522-1.85-2.828z",
    fill: "#ECB24A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F8C75F",
    fillRule: "nonzero",
    transform: "rotate(-33.38 47.55 10.92)",
    cx: 47.551,
    cy: 10.92,
    rx: 1,
    ry: 1.69
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#143A47",
    strokeWidth: 2.275,
    d: "m5.375 34.146.641 6.857"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#143A47",
    strokeWidth: 2.275,
    strokeLinecap: "round",
    d: "m24.87 17.285-.014-.436 6.636-11.375 2.696-1.63M28.107 37.795l3.47 6.286c.577 1.044 2.126.829 2.401-.333l3.747-15.816-.115-3.576 6.637-11.375 2.696-1.63"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#77B2BF",
    fillRule: "nonzero",
    d: "m18.361 37.73-.043-.247-15.646-9.559.415 1.721z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6DFE4",
    fillRule: "nonzero",
    d: "M.345 26.705 18.5 37.733l22.303-13.56-17.71-10.402z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5394A5",
    fillRule: "nonzero",
    d: "m2.408 26.699 15.58 9.473 20.42-11.877-15.859-9.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#77B2BF",
    fillRule: "nonzero",
    d: "m2.342 26.675 5.333 3.184 14.984-8.905-.11-5.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#77B2BF",
    fillRule: "nonzero",
    d: "m3.039 26.271 5.236 3.166.133-.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8ECFDA",
    fillRule: "nonzero",
    d: "m22.601 21.002 10.614 6.467 5.328-3.084-16.025-9.28zM18.237 37.682l2.247 7.084 18.165-10.527 2.05-10.036z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.118 53.981-4.406-2.82a2.927 2.927 0 0 1-.551-.946c-.137-.392-.153-.718-.157-1.328-.007-.979-.01-1.469.031-1.833.192-1.726 1.191-3.172 1.663-3.855.717-1.039 1.435-2.077 2.823-2.813a6.67 6.67 0 0 1 2.949-.759l4.331 2.55",
    fill: "#414F56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#10212B",
    fillRule: "nonzero",
    transform: "rotate(-59.15 8.548 48.148)",
    cx: 8.548,
    cy: 48.148,
    rx: 6.77,
    ry: 3.938
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F8C75F",
    fillRule: "nonzero",
    transform: "rotate(-59.36 8.633 48.093)",
    cx: 8.633,
    cy: 48.093,
    rx: 5.708,
    ry: 2.973
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#143A47",
    strokeWidth: 2.275,
    d: "m10.159 47.51 7.892-5.116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.632 50.132-1.313-.84a.87.87 0 0 1-.164-.282c-.04-.117-.046-.214-.047-.396-.001-.291-.002-.437.01-.546.057-.514.354-.945.495-1.148.214-.31.427-.619.841-.838.349-.184.68-.22.878-.225l1.29.759",
    fill: "#CACEE2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E3E7EF",
    fillRule: "nonzero",
    transform: "rotate(-59.15 9.653 48.396)",
    cx: 9.653,
    cy: 48.396,
    rx: 2.016,
    ry: 1.173
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#77B2BF",
    fillRule: "nonzero",
    d: "m.555 26.717 2.33 7.262L20.479 44.81l-2.117-7.081z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtCarouselWheelBarrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-carousel-wheel-barrow.15cb782124881c0f33d371b17819bb32.svg";